module.exports = __webpack_public_path__ + "img/person-2.1ed828d.webp";